const URL = {
  //publicApi: "http://devapi.dbclass.jzddyr.com:81",
  publicApi: "https://api.dbclass.cn",
  // publicApi: "http://localhost:9903",
  publicPostset: "application/x-www-form-urlencoded",
  publicPhoneAddress: "/"
}
export default URL;


// WEBPACK FOOTER //
// ./src/apis/network.js